import { render, staticRenderFns } from "./garbage-centers.vue?vue&type=template&id=58d4430a&"
import script from "./garbage-centers.vue?vue&type=script&lang=js&"
export * from "./garbage-centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports